import at from "lodash/at";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(void 0);
        });
    };
}
const NUMBER_B_IN_MB = 1048576;
const DEFAULT_SIZE_LIMIT = 20;
const validateFile = (file, message, fileTypes, fileTypeChecker)=>_async_to_generator(function*() {
        let fileType = yield fileTypeChecker.fileTypeFromBlob(file);
        if (null == file ? void 0 : file.name.includes('.sig')) fileType = 'application/pgp-signature';
        else if (null == file ? void 0 : file.name.includes('.p7m')) fileType = 'application/pkcs7-mime';
        return !fileTypes.includes(fileType) || file.size > DEFAULT_SIZE_LIMIT * NUMBER_B_IN_MB ? message : void 0;
    })();
const getImageResolution = (file)=>new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = ()=>{
            const img = new Image();
            img.onload = ()=>{
                resolve({
                    width: img.width,
                    height: img.height
                });
            };
            img.onerror = reject;
            img.src = reader.result;
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
class ValidationService {
    constructor(fileType){
        this.fileType = fileType;
        this.required = (message = 'Обязательное поле')=>(value)=>null == value || 'boolean' == typeof value && false === value || 'string' == typeof value && '' === value.trim() || Array.isArray(value) && 0 === value.length ? message : void 0;
        this.requiredIfFile = (message = 'Обязательное поле', options)=>{
            const fileTypeChecker = this.fileType;
            return function validateValue(value) {
                return _async_to_generator(function*() {
                    if (!value || 'string' == typeof value || 'string' == typeof (null == value ? void 0 : value.source)) return;
                    if (Array.isArray(value)) {
                        for (const arrItem of value){
                            const error = yield validateValue(arrItem);
                            if (error) return error;
                        }
                        return;
                    }
                    {
                        const result = yield validateFile((null == value ? void 0 : value.source) || value, message, options.fileTypes, fileTypeChecker);
                        return result;
                    }
                })();
            };
        };
        this.maxValue = (max, message)=>(value)=>Number(value) > Number(max) ? message : void 0;
        this.minValue = (min, message)=>(value)=>Number(value) < Number(min) ? message : void 0;
        this.sizeLimit = (message = 'Объем файла слишком большой', options)=>function validateValue(value, allValues) {
                const sizeLimit = options.sizeLimit * NUMBER_B_IN_MB;
                if (!value || 'string' == typeof value || 'string' == typeof (null == value ? void 0 : value.source)) return;
                if (Array.isArray(value)) {
                    const res = value.reduce((error, arrItem)=>error || validateValue(arrItem, allValues), void 0);
                    return res;
                }
                var _value_source;
                return at(allValues, options.field)[0] && (null == (_value_source = value.source) ? void 0 : _value_source.size) > sizeLimit ? message : void 0;
            };
        this.imageResolutionCheck = (_, options)=>function(value) {
                return _async_to_generator(function*() {
                    if (void 0 === value) return;
                    const files = Array.isArray(value) ? value : [
                        value
                    ];
                    for (const { source: file } of files){
                        if ('string' == typeof file) break;
                        try {
                            const { width, height } = yield getImageResolution(file);
                            if (width < options.minWidth) return 'Недопустимые параметры изображения';
                            if (height < options.minHeight) return 'Недопустимые параметры изображения';
                        } catch (error) {
                            return `${file.name}: Ошибка при загрузке изображения`;
                        }
                    }
                })();
            };
        this.validUrl = (message = 'Значение поля должно быть ссылкой', allowedProtocols = [
            'http:',
            'https:',
            'mailto:',
            'tel:',
            'sms:'
        ])=>(value)=>{
                if (!value) return;
                try {
                    const parsedUrl = new URL(value);
                    if (!allowedProtocols.includes(parsedUrl.protocol)) return message;
                    return;
                } catch (_) {
                    return message;
                }
            };
        this.containsSupportedProtocol = (message = 'Ссылка должна содержать поддерживаемый протокол')=>(value)=>{
                if (!value) return;
                const SUPPORTED_PROTOCOLS = [
                    'http:',
                    'https:',
                    'mailto:',
                    'sms:',
                    'tel:'
                ];
                try {
                    const parsedUrl = new URL(value);
                    const hasSupportedProtocol = SUPPORTED_PROTOCOLS.includes(parsedUrl.protocol);
                    if (!hasSupportedProtocol) return message;
                    if ('http:' === parsedUrl.protocol || 'https:' === parsedUrl.protocol) {
                        const hasDoubleSlash = value.includes('://');
                        return hasDoubleSlash ? void 0 : 'Ссылка должна содержать // после протокола';
                    }
                    return;
                } catch (unused) {
                    return message;
                }
            };
    }
}
export { ValidationService, getImageResolution, validateFile };
